// src/hooks/products/useProductForm.js

import { useState, useEffect } from "react";
import toast from "react-hot-toast";
import { INITIAL_FORM_DATA } from "../../components/products/ProductForm/helpers/formConstants";
import { initializeFormData } from "../../components/products/ProductForm/helpers/formInitializer";
// import { INITIAL_FORM_DATA } from "../components/products/ProductForm/helpers/formConstants";
// import { initializeFormData } from "../components/products/ProductForm/helpers/formInitializer";
import { validateStep as validateFormStep } from "../../components/products/ProductForm/helpers/formValidator";
import { buildPayload as buildFormPayload } from "../../components/products/ProductForm/helpers/payloadBuilder";

/**
 * ✅ Custom hook for product form management
 */
const useProductForm = (isEdit, currentData, isArabic) => {
    const initialStep = isEdit ? 1 : 0;

    const [currentStep, setCurrentStep] = useState(initialStep);
    const [formData, setFormData] = useState(INITIAL_FORM_DATA);
    const [errors, setErrors] = useState({});

    // Initialize form data in edit mode
    useEffect(() => {
        if (isEdit && currentData) {
            const initializedData = initializeFormData(currentData);
            setFormData(initializedData);
        }
    }, [isEdit, currentData]);

    // Validate current step
    const validateStep = (step) => {
        const newErrors = validateFormStep(step, formData, isEdit, isArabic);
        setErrors(newErrors);
        return newErrors;
    };

    // Handle next step
    const handleNext = () => {
        const stepErrors = validateStep(currentStep);
        if (Object.keys(stepErrors).length > 0) {
            toast.error(
                isArabic
                    ? `الرجاء تعبئة جميع الحقول المطلوبة بشكل صحيح: ${Object.keys(stepErrors).join(', ')}`
                    : `Please fill all required fields correctly: ${Object.keys(stepErrors).join(', ')}`
            );
            return false;
        }

        setCurrentStep((prev) => prev + 1);
        setErrors({});
        return true;
    };

    // Handle previous step
    const handleBack = () => {
        const minStep = isEdit ? 1 : 0;

        if (currentStep > minStep) {
            setCurrentStep((prev) => prev - 1);
            setErrors({});
        }
    };

    // Build payload for submission
    const buildPayload = () => {
        return buildFormPayload(formData);
    };

    return {
        currentStep,
        formData,
        setFormData,
        errors,
        setErrors,
        validateStep,
        handleNext,
        handleBack,
        buildPayload,
    };
};

export default useProductForm;
